import React from 'react'
import { SMARTQUOTE_CLOSE, SMARTQUOTE_OPEN } from '../../utils'
import { RichText } from '../RichText'
import { Text } from '../Text'
import { TextLink } from '../TextLink'
import { IProps } from './index'
import { TestimonialDetails as TestimonialDetailsDefault } from './element'
import { BrandOptions, useBrand } from '../../providers/brandProvider'

export function TestimonialDetails(props: IProps) {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <TestimonialDetailsDefault {...props} />
  }
  return <TestimonialDetailsLegacy {...props} />
}

export class TestimonialDetailsLegacy extends React.PureComponent<IProps> {
  render() {
    const {
      headline,
      sanitizedHeadline,
      quote,
      companyLogo,
      name,
      jobTitle,
      companyName,
      externalLink,
    } = this.props

    const companyNameContent = externalLink ? (
      <TextLink url={externalLink}>
        <Text size="body">{companyName}</Text>
      </TextLink>
    ) : (
      <Text size="body">{companyName}</Text>
    )

    return (
      <div className="testimonial-details">
        {sanitizedHeadline && headline && (
          <div className="testimonial-headline">
            <Text size="xl">
              <RichText html={headline} />
            </Text>
          </div>
        )}
        <div className="testimonial-quote">
          <span className="left-quote">
            <Text size="body">{SMARTQUOTE_OPEN}</Text>
          </span>
          <Text size="body">
            {quote}
            {SMARTQUOTE_CLOSE}
          </Text>
        </div>

        <div className="testimonial-profile">
          {companyLogo && (
            <div className="testimonial-profile__column">
              <img className="testimonial-profile__company-logo" src={companyLogo} alt="" />
            </div>
          )}
          <div className="testimonial-profile__column">
            {name && (
              <div className="testimonial-profile__name">
                <Text size="body+">{name}</Text>
              </div>
            )}
            {(jobTitle || companyName) && (
              <div className="testimonial-profile__job-title-company-name-wrapper">
                {jobTitle && (
                  <div className="testimonial-profile__job-title">
                    <Text size="body">{jobTitle}</Text>
                  </div>
                )}
                {companyName && (
                  <div className="testimonial-profile__company-name">{companyNameContent}</div>
                )}
              </div>
            )}
          </div>
        </div>
        <style jsx>
          {`
            .testimonial-details {
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              padding: 2.25rem 0 0;
            }
            :global(.testimonial-details .rich-text p) {
              line-height: 1.2;
            }
            .testimonial-quote {
              padding-top: 0px;
              padding-bottom: 1.25rem;
              line-height: 1.6;
            }
            .testimonial-headline + .testimonial-quote {
              padding-top: 1.25rem;
            }
            .left-quote {
              margin-left: -7px;
            }
            .testimonial-profile {
              display: flex;
              align-items: flex-start;
            }
            .testimonial-profile__column {
              display: flex;
              flex-direction: column;
            }
            .testimonial-profile__company-logo {
              /* emblem-only logo image, size-limited to sit next to text block */
              max-width: 30px;
              max-height: 30px;
              padding-right: 0.75em;
            }
            .testimonial-profile__name {
              display: inline-block;
            }
            .testimonial-profile__job-title-company-name-wrapper {
              padding-top: 6px;
            }
            .testimonial-profile__job-title,
            .testimonial-profile__company-name {
              display: inline;
            }
            .testimonial-profile__job-title-company-name-wrapper
              .testimonial-profile__job-title
              + .testimonial-profile__company-name::before {
              content: ', ';
            }
          `}
        </style>
      </div>
    )
  }
}
